import React, { Component } from 'react'
import { connect } from 'react-redux'
import { HomeImageComponent } from '../components'
import { saveHomeImage, resetHomeImage } from '../actions'
import { updateRequestState, getRequestState } from '../../../shared/actions'
import { isEqual } from 'lodash'

class HomeImage extends Component {
    constructor(props) {
        super(props)

        this.state = {
            step: 1,
            homeImage: props.homeImage,
            isCameraOn: false
        }
    }

    componentDidMount = () => {
        this.props.getRequestState()
        if (this.props.history.location.params && this.props.history.location.params.to === 'preview') {
            this.resetHomeImage()
        } else if (this.state.homeImage) {
            this.setState({ step: 2 })
        }
    }

    goToScreen = (key, params) => {
        if (this.props.history.location && this.props.history.location.params) {
            this.props.history.push(this.props.history.location.params.to)
        } else {
            this.props.history.push({
                pathname: key,
                params: params,
            })
        }
    }

    resetHomeImage = () => {
        this.setState({ step: 1, homeImage: '' })
        this.props.resetHomeImage()
    }

    goBack = () => {
        if (this.state.step === 2) {
            this.resetHomeImage()
        } else {
            this.props.history.replace("documents")
        }
    }

    captureImage = (image) => {
        this.setState({ step: 2, homeImage: image })
    }

    handleChange = (key, value) => {
        this.setState({ [key]: value })
    }

    submit = () => {
        if (!isEqual(this.state.homeImage, this.props.homeImage)) {
            this.props.updateRequestState({
                upload: ['home_image'],
                state: "home_image_captured",
                data: {
                    home_image: this.state.homeImage
                },
                nextRoute: 'video'
            })
        } else {
            this.goToScreen('video')
        }
    }

    render() {
        const { language, languageJSON } = this.props
        const { step, homeImage, isCameraOn } = this.state
        return (
            <HomeImageComponent
                step={step}
                isCameraOn={isCameraOn}
                goBack={this.goBack}
                goToScreen={this.goToScreen}
                language={language}
                languageJSON={languageJSON}
                homeImage={homeImage}
                captureImage={this.captureImage}
                submit={this.submit}
                handleChange={this.handleChange}
            />
        )
    }
}

const mapStateToProps = ({ language: { language, languageJSON }, homeImage: { homeImage } }) => ({
    language,
    homeImage,
    languageJSON
})

const mapDispatchToProps = {
    saveHomeImage,
    resetHomeImage,
    updateRequestState,
    getRequestState
}

export default connect(mapStateToProps, mapDispatchToProps)(HomeImage)

